!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, n = t.parcelRequire5f74;
  null == n && ((n = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var n = i[t];
      delete i[t];
      var s = {
        id: t,
        exports: {}
      };
      return e[t] = s, n.call(s.exports, s, s.exports), s.exports;
    }
    var a = new Error("Cannot find module '" + t + "'");
    throw a.code = "MODULE_NOT_FOUND", a;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = n), (0, n.register)("gjV2B", function(t, e) {
    var i, n, s, a;
    i = t.exports, n = "debounce", s = function() {
      return h;
    }, Object.defineProperty(i, n, {
      get: s,
      set: a,
      enumerable: !0,
      configurable: !0
    });
    const h = (t, e) => {
      let i;
      const n = (...n) => {
        clearTimeout(i), i = setTimeout(() => {
          clearTimeout(i), t(...n);
        }, e);
      };
      return n.cancel = () => {
        clearTimeout(i), i = null;
      }, n;
    };
  });
  var s = n("gjV2B");
  var a = class {
    constructor(t, e, i = 3) {
      this.updateFloor = () => this.update("floor"), this.updateCeil = () => this.update("ceil"), 
      this.$min = t, this.$max = e, this.precision = i, this.$min.addEventListener("input", this.updateCeil), 
      this.$max.addEventListener("input", this.updateFloor), this.$min.addEventListener("focus", this.updateCeil), 
      this.$max.addEventListener("focus", this.updateFloor), this.$min.addEventListener("mousedown", this.updateCeil), 
      this.$max.addEventListener("mousedown", this.updateFloor), this.$min.addEventListener("touchstart", this.updateCeil), 
      this.$max.addEventListener("touchstart", this.updateFloor), this.update(), this.$min.dataset.ready = "true", 
      this.$max.dataset.ready = "true";
    }
    update(t = "ceil") {
      const e = "var(--dri-thumb-width)", i = parseFloat(this.$min.min), n = parseFloat(this.$max.max), s = parseFloat(this.$min.step) || 1, a = parseFloat(this.$min.value), h = parseFloat(this.$max.value), r = (h - a) / 2, l = a + Math[t](r / s) * s, o = n - i, u = ((l - i) / o * 100).toFixed(this.precision), d = ((n - l) / o * 100).toFixed(this.precision);
      this.$min.style.flexBasis = `calc(${u}% + ${e})`, this.$max.style.flexBasis = `calc(${d}% + ${e})`, 
      this.$min.max = l.toFixed(this.precision), this.$max.min = l.toFixed(this.precision);
      const p = (a - i) / (l - i) || 0, c = (h - l) / (n - l) || 0, g = (100 * p).toFixed(this.precision), m = (100 * c).toFixed(this.precision), E = (.5 - p).toFixed(this.precision), v = (.5 - c).toFixed(this.precision);
      this.$min.style.setProperty("--dri-gradient-position", `calc(${g}% + (${E} * ${e}))`), 
      this.$max.style.setProperty("--dri-gradient-position", `calc(${m}% + (${v} * ${e}))`);
    }
    destroy() {
      this.$min.removeEventListener("input", this.updateFloor), this.$max.removeEventListener("input", this.updateCeil), 
      this.$min.removeEventListener("focus", this.updateFloor), this.$max.removeEventListener("focus", this.updateCeil), 
      this.$min.removeEventListener("mousedown", this.updateCeil), this.$max.removeEventListener("mousedown", this.updateFloor), 
      this.$min.removeEventListener("touchstart", this.updateCeil), this.$max.removeEventListener("touchstart", this.updateFloor);
    }
  };
  customElements.get("range-slider") || customElements.define("range-slider", class extends HTMLElement {
    constructor() {
      super(), this.DRI = null, this.isUpdating = !1, this.rangeMinEl = this.querySelector("[data-range-min]"), 
      this.rangeMaxEl = this.querySelector("[data-range-max]"), this.inputMinEl = this.querySelector("[data-input-min]"), 
      this.inputMaxEl = this.querySelector("[data-input-max]"), this.handleRangeChange = this.handleRangeChange.bind(this), 
      this.handleInputChange = this.handleInputChange.bind(this), this.debouncedInputChange = (0, 
      s.debounce)(this.handleInputChange, 300);
    }
    handleRangeChange(t) {
      this.isUpdating || (this.isUpdating = !0, t.target === this.rangeMinEl && this.inputMinEl && (this.inputMinEl.value = t.target.value, 
      this.inputMinEl.dispatchEvent(new Event("input", {
        bubbles: !0
      })), this.inputMinEl.dispatchEvent(new Event("change", {
        bubbles: !0
      }))), t.target === this.rangeMaxEl && this.inputMaxEl && (this.inputMaxEl.value = t.target.value, 
      this.inputMaxEl.dispatchEvent(new Event("input", {
        bubbles: !0
      })), this.inputMaxEl.dispatchEvent(new Event("change", {
        bubbles: !0
      }))), this.triggerFormSubmission(), setTimeout(() => {
        this.isUpdating = !1;
      }, 10));
    }
    handleInputChange(t) {
      this.isUpdating || (this.isUpdating = !0, t.target === this.inputMinEl && this.rangeMinEl && (this.rangeMinEl.value = t.target.value, 
      this.DRI && this.DRI.update()), t.target === this.inputMaxEl && this.rangeMaxEl && (this.rangeMaxEl.value = t.target.value, 
      this.DRI && this.DRI.update()), this.triggerFormSubmission(), setTimeout(() => {
        this.isUpdating = !1;
      }, 10));
    }
    triggerFormSubmission() {
      const t = this.closest("facet-filters-form");
      if (t) {
        const e = t.querySelector("form");
        if (e) {
          const t = new Event("input", {
            bubbles: !0
          });
          e.dispatchEvent(t);
        }
      }
    }
    connectedCallback() {
      this.rangeMinEl && this.rangeMaxEl && (this.rangeMinEl.addEventListener("input", this.handleRangeChange), 
      this.rangeMaxEl.addEventListener("input", this.handleRangeChange), this.DRI = new a(this.rangeMinEl, this.rangeMaxEl)), 
      this.inputMinEl && this.inputMaxEl && (this.inputMinEl.addEventListener("input", this.debouncedInputChange), 
      this.inputMaxEl.addEventListener("input", this.debouncedInputChange));
    }
    disconnectedCallback() {
      this.rangeMinEl && this.rangeMaxEl && (this.rangeMinEl.removeEventListener("input", this.handleRangeChange), 
      this.rangeMaxEl.removeEventListener("input", this.handleRangeChange)), this.inputMinEl && this.inputMaxEl && (this.inputMinEl.removeEventListener("input", this.debouncedInputChange), 
      this.inputMaxEl.removeEventListener("input", this.debouncedInputChange)), this.DRI && (this.DRI.destroy(), 
      this.DRI = null);
    }
  });
}();